import * as Draft from "draft-js";
import { Map } from "immutable";
import * as React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { PostMessageViewModel } from "~/messageBoard";
import { AiSuggestionBlock } from "~/messageBoard/ai/components/AiSuggestionBlock";
import { getAiSuggestion } from "~/messageBoard/ai/state/selectors";
import { AiSuggestionBlockName } from "~/messageBoard/ai/types";
import { addSuggestion, getTextWithoutSuggestion } from "~/messageBoard/ai/utils";
import { useMessageContext } from "~/messageBoard/messageContext";
import { useApplySuggestions } from "../hooks/useApplySuggestions";

const blockRenderMap = Map({
    [AiSuggestionBlockName]: {
        // element is used during paste or html conversion to auto match your component;
        // it is also retained as part of this.props.children and not stripped out
        element: "div",
        wrapper: <AiSuggestionBlock />,
    },
});

// keep support for other draft default block types and add our myCustomBlock type
const extendedBlockRenderMap = Draft.DefaultDraftBlockRenderMap.merge(blockRenderMap);

export const useAICompletion = () => {
    const suggestion = useSelector(getAiSuggestion);
    const vm = useMessageContext<PostMessageViewModel>();

    const { discard } = useApplySuggestions(vm);
    const text = getTextWithoutSuggestion(vm.editorState());

    useEffect(() => {
        if (suggestion) {
            const result = addSuggestion(vm.editorState(), suggestion);
            vm.editorState(result);
        }
    }, [suggestion]);

    useEffect(() => {
        if (suggestion) {
            // if user starts editing his original message then discard the ai response
            discard();
        }
    }, [text]);

    return { extendedBlockRenderMap };
};
